@if (comfirmationModelType === 'UNLOCK_APS') {
<app-dialog-title>
  {{ "are-you-sure-you-want-to-create-a-revision" | transloco }}
</app-dialog-title>
<mat-dialog-content
  class="content"
  >{{ 'unlock-tax-return-alias-in-aps-once-you-are-certain-this-return-has-been-unlocked-in-aps-click-begin-revision' | transloco: {taxReturnAlias} }}</mat-dialog-content
>
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button (click)="confirmRevise(); onClose(true)" class="ui primary button">
    {{ "begin-revision" | transloco }}
  </button>
</mat-dialog-actions>
} @if (comfirmationModelType === 'REVISION_COUNT') {
<app-dialog-title>
  {{ "are-you-sure-you-want-to-create-a-revision" | transloco }}
</app-dialog-title>
<mat-dialog-content class="content">
  <p>
    {{ "according-to-our-record-this-is-going-to-be-the" | transloco }}
    <strong>{{ taxReturn.revisionCount + 1 | numberOrdinal }}</strong>
    {{ 'revision-of-this-tax-return-alias' | transloco:{taxReturnAlias} }}
    {{
      "please-update-the-revision-number-below-if-this-is-not-right" | transloco
    }}
  </p>
  <div class="revision-count-block field">
    <label class="form-control-label">{{
      "revision-number" | transloco
    }}</label>
    <input
      [(ngModel)]="revisionCount"
      type="number"
      class="form-control revision-count"
      #revisionCountCtrl="ngModel"
      required
      pattern="^[1-9][0-9]*$"
      min="1"
    />
    @if (revisionCountCtrl.invalid) {
    <div class="form-control-error">
      {{ "please-enter-an-valid-revision-number" | transloco }}
    </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    [disabled]="revisionCountCtrl.invalid"
    (click)="confirmRevise(); onClose(true)"
    class="ui primary button"
  >
    {{ "begin-revision" | transloco }}
  </button>
</mat-dialog-actions>
} @if (comfirmationModelType === 'CONFIRMATION') {
<app-dialog-title>{{ "create-a-revision" | transloco }}</app-dialog-title>
<mat-dialog-content class="content">
  <p>
    {{ 'are-you-sure-you-want-to-revise-the-tax-return-alias-for' | transloco: {taxReturnAlias} }}
    <strong>{{ taxReturn.firstName }} {{ taxReturn.lastName }}</strong
    >.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button (click)="confirmRevise(); onClose(true)" class="ui primary button">
    {{ "begin-revision" | transloco }}
  </button>
</mat-dialog-actions>
}
